var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_246_5063",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "master_svg2e_0_2441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_246_5063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6 4.8C6.94903 4.8 4.8 6.94903 4.8 9.6C4.8 12.251 6.94903 14.4 9.6 14.4C12.251 14.4 14.4 12.251 14.4 9.6C14.4 6.94903 12.251 4.8 9.6 4.8ZM2.4 9.6C2.4 5.62355 5.62355 2.4 9.6 2.4C13.5765 2.4 16.8 5.62355 16.8 9.6C16.8 11.155 16.307 12.5949 15.4688 13.7718L21.2485 19.5515C21.7171 20.0201 21.7171 20.7799 21.2485 21.2485C20.7799 21.7171 20.0201 21.7171 19.5515 21.2485L13.7718 15.4688C12.5949 16.307 11.155 16.8 9.6 16.8C5.62355 16.8 2.4 13.5765 2.4 9.6Z",
    fill: "#FFB829"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.bd319ca36625f40fce3f5b88732e8012.svg";
export { ForwardRef as ReactComponent };